module.exports = __webpack_public_path__ + "media/@sample.0c481e87.mp3";